import {
  GetSubscriptionRequestAction,
  GetSubscriptionSuccessAction,
  GetSubscriptionFailureAction,
  StartSubscriptionPollingRequestAction,
  DeleteSubscriptionSuccessAction,
  UpdateSubscriptionRequestAction,
  UpdateSubscriptionSuccessAction,
  UpdateSubscriptionFailureAction,
  ResetUpdateSubscriptionAction,
  SetSubscriptionsStatusAction,
  AddNewSubscriptionAction
} from './subscriptions.types';

export const startSubscriptionsPolling = (): StartSubscriptionPollingRequestAction => ({
  type: 'START_SUBSCRIPTIONS_POLLING'
});

export const getSubscriptions = (): GetSubscriptionRequestAction => ({
  type: 'GET_SUBSCRIPTIONS_REQUEST'
});

export const setSubscriptionsStatus = (
  payload: ReducerStateStatus
): SetSubscriptionsStatusAction => ({
  type: 'SET_SUBSCRIPTIONS_STATUS',
  payload
});

export const getSubscriptionsSuccess = (data: SubById): GetSubscriptionSuccessAction => ({
  type: 'GET_SUBSCRIPTIONS_SUCCESS',
  payload: data
});

export const getSubscriptionsFailure = (error: string): GetSubscriptionFailureAction => ({
  type: 'GET_SUBSCRIPTIONS_FAILURE',
  payload: error
});

export const deleteSubscriptionSuccess = (subsId: number): DeleteSubscriptionSuccessAction => ({
  type: 'DELETE_SUBSCRIPTION_SUCCESS',
  payload: subsId
});

export const updateSubscriptionRequest = (
  payload: UpdateSubscriptionRequestAction['payload']
): UpdateSubscriptionRequestAction => ({
  type: 'UPDATE_SUBSCRIPTION_REQUEST',
  payload
});

export const updateSubscriptionSuccess = (
  payload: Subscription
): UpdateSubscriptionSuccessAction => ({
  type: 'UPDATE_SUBSCRIPTION_SUCCESS',
  payload
});

export const updateSubscriptionFailure = (error: string): UpdateSubscriptionFailureAction => ({
  type: 'UPDATE_SUBSCRIPTION_FAILURE',
  payload: error
});

export const resetUpdateSubscriptionState = (): ResetUpdateSubscriptionAction => ({
  type: 'RESET_UPDATE_SUBSCRIPTION_STATE'
});

export const addNewSubscription = (subscription: Subscription): AddNewSubscriptionAction => ({
  type: 'ADD_NEW_SUBSCRIPTION',
  payload: subscription
});
